module.exports = __webpack_public_path__ + "img/product_service31.be24b6cd.png";